// extracted by mini-css-extract-plugin
export default {"collapse":"collapse___XNZUN","open":"open___JYh2Z"};